import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../../constants/Common';

const Advertisement = (props) => {
  const [src, setSrc] = useState('');
  useEffect(() => {
    if (props.image && props.image.images && props.image.images.length !== 0) {
      setSrc(BASE_URL + props.image.images[0]);
    }
  }, [props.image]);
  return (
    <>
      {props.image && props.image.images && props.image.images.length !== 0 && (
        <div className="advertisementImage">
          <img
            onError={() => {
              // setSrc(require("../../assets/img/dashboard/banner.jpg"))
            }}
            src={src}
            alt="banner"
          />
        </div>
      )}
    </>
  );
};
export default Advertisement;
